"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NotificationsService", {
    enumerable: true,
    get: function() {
        return NotificationsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _catchError = require("~/helpers/catchError");
const _PagedResponse = require("~/helpers/PagedResponse");
const _models = require("~/models");
const _pubsubredis = require("~/redis/pubsub-redis");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let NotificationsService = class NotificationsService {
    sendToConnections(key, payload) {
        const connections = this.connections.get(String(key));
        for (const res of connections != null ? connections : []){
            res.send({
                status: 'success',
                data: payload
            });
        }
        this.removeConnectionByUserId(key);
    }
    removeConnectionByUserId(userId) {
        this.connections.delete(userId);
    }
    async insertNotification(insertData, _req) {
        await _models.Notification.insert(insertData);
        if (_pubsubredis.PubSubRedis.available) {
            await _pubsubredis.PubSubRedis.publish(`notification:${insertData.fk_user_id}`, JSON.stringify(insertData, (0, _nocodbsdk.getCircularReplacer)()));
        }
        this.sendToConnections(insertData.fk_user_id, JSON.stringify(insertData, (0, _nocodbsdk.getCircularReplacer)()));
    }
    async notificationList(param) {
        try {
            const { limit = 10, offset = 0, is_read } = param;
            const list = await _models.Notification.list({
                fk_user_id: param.user.id,
                is_read,
                limit,
                offset,
                is_deleted: false
            });
            const count = await _models.Notification.count({
                fk_user_id: param.user.id,
                is_deleted: false
            });
            const unreadCount = await _models.Notification.count({
                fk_user_id: param.user.id,
                is_deleted: false,
                is_read: false
            });
            return new _PagedResponse.PagedResponseImpl(list, {
                limit: param.limit,
                offset: param.offset,
                count
            }, {
                unreadCount
            });
        } catch (e) {
            this.logger.error(e);
        }
    }
    async notificationUpdate(param) {
        const notification = await _models.Notification.get({
            id: param.notificationId,
            fk_user_id: param.user.id
        });
        if (!notification) {
            _catchError.NcError.unauthorized('Unauthorized to update notification');
        }
        await _models.Notification.update(param.notificationId, param.body);
        return true;
    }
    async notificationDelete(param) {
        const notification = await _models.Notification.get({
            id: param.notificationId,
            fk_user_id: param.user.id
        });
        if (!notification) {
            _catchError.NcError.unauthorized('Unauthorized to delete notification');
        }
        await _models.Notification.update(param.notificationId, {
            is_deleted: true
        });
    }
    async markAllRead(param) {
        var _param_user;
        if (!((_param_user = param.user) == null ? void 0 : _param_user.id)) {
            _catchError.NcError.badRequest('User id is required');
        }
        await _models.Notification.markAllAsRead(param.user.id);
        return true;
    }
    async hookHandler({ event, data }) {
        const { req } = data;
        switch(event){
            case _nocodbsdk.AppEvents.PROJECT_INVITE:
                {
                    const { base, user, invitedBy } = data;
                    await this.insertNotification({
                        fk_user_id: user.id,
                        type: _nocodbsdk.AppEvents.PROJECT_INVITE,
                        body: {
                            base: {
                                id: base.id,
                                title: base.title,
                                type: base.type
                            },
                            user: {
                                id: invitedBy.id,
                                email: invitedBy.email,
                                displayName: invitedBy.display_name,
                                meta: invitedBy.meta
                            }
                        }
                    }, req);
                }
                break;
            case _nocodbsdk.AppEvents.WELCOME:
                {
                    const { user, req } = data;
                    await this.insertNotification({
                        fk_user_id: user.id,
                        type: _nocodbsdk.AppEvents.WELCOME,
                        body: {}
                    }, req);
                }
                break;
        }
    }
    onModuleDestroy() {
        this.appHooks.removeAllListener(this.hookHandler);
    }
    onModuleInit() {
        this.appHooks.on(_nocodbsdk.AppEvents.PROJECT_INVITE, (data)=>this.hookHandler({
                event: _nocodbsdk.AppEvents.PROJECT_INVITE,
                data
            }));
        this.appHooks.on(_nocodbsdk.AppEvents.WELCOME, (data)=>this.hookHandler({
                event: _nocodbsdk.AppEvents.WELCOME,
                data
            }));
    }
    constructor(appHooks){
        this.appHooks = appHooks;
        this.logger = new _common.Logger(NotificationsService.name);
        this.connections = new Map();
        this.addConnection = (userId, res)=>{
            if (!this.connections.has(userId)) {
                this.connections.set(userId, []);
            }
            this.connections.get(userId).push(res);
        };
        this.removeConnection = async (userId, res, unsubscribeCb)=>{
            if (!this.connections.has(userId)) {
                return;
            }
            const userConnections = this.connections.get(userId);
            const idx = userConnections.findIndex((c)=>c.resId === res.resId);
            if (idx > -1) {
                userConnections.splice(idx, 1);
            }
            if (userConnections.length === 0) {
                this.connections.delete(userId);
                if (unsubscribeCb) {
                    await unsubscribeCb();
                }
            } else {
                this.connections.set(userId, userConnections);
                if (unsubscribeCb) {
                    // if there are still connections, keep the redis channel
                    await unsubscribeCb(true);
                }
            }
        };
    }
};
NotificationsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], NotificationsService);
